import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { AuthModule } from "@auth0/auth0-angular";
import { environment as ENV } from "@environments/environment";

// Modules
import { AppRoutingModule } from "@app/app-routing.module";
import { CoreModule } from "@core/core.module";

// Consts
import { environment } from "@environments/environment";

// Components
import { AppComponent } from "./app.component";

// Services
import { WebAdapterService } from "@core/web-adapter/web-adapter.service";
import { GlobalErrorHandler } from "@core/services/global-error-handler";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    AuthModule.forRoot({
      domain: ENV.auth0.domain,
      clientId: ENV.auth0.clientId,
      authorizationParams: {
        redirect_uri: ENV.auth0.redirectUri,
      },
    }),
  ],
  providers: [
    WebAdapterService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
